import { Locale } from '@doordash/lib-i18n'
import { COOKIE_AGE_ONE_YEAR } from '../../constants'
import { createCookie } from '../../utilities/SimpleStore'

const setLocaleToCookie = (locale: Locale) => {
  createCookie('dd_language', locale, COOKIE_AGE_ONE_YEAR)
}

export default setLocaleToCookie
